import { Type } from 'class-transformer';
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
import { AccOpenStatusItemResultDto } from './acc-open-status-item-result-dto';

export class AccOpenStatusResultDto {
    allowViewEdit: boolean;
    allowChangeStatus: boolean;
    allowChangeOwner: boolean;
    allowSendEmailReminder: boolean;

    @Type(() => KeyValueResultDto)
    statusResult: KeyValueResultDto[];

    @Type(() => KeyValueResultDto)
    serviceTeamData: KeyValueResultDto[];

    @Type(() => KeyValueResultDto)
    boardCommitteeData: KeyValueResultDto[];

    @Type(() => AccOpenStatusItemResultDto)
    openItems: AccOpenStatusItemResultDto[];
}
